import { render, staticRenderFns } from "./NotiTabs.vue?vue&type=template&id=455ee87d&scoped=true&"
import script from "./NotiTabs.vue?vue&type=script&lang=js&"
export * from "./NotiTabs.vue?vue&type=script&lang=js&"
import style0 from "./NotiTabs.vue?vue&type=style&index=0&id=455ee87d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ee87d",
  null
  
)

export default component.exports